var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    { staticClass: "form__group" },
    [
      _c("div", { staticClass: "gl-forms__container" }, [
        _c("div", { staticClass: "gl-forms__title" }, [
          _vm._v(" " + _vm._s(_vm.$t("admins.info")) + " ")
        ]),
        _c("div", { staticClass: "gl-grid-form" }, [
          _c(
            "div",
            { staticClass: "form__group col-1" },
            [
              _c("gl-input", {
                directives: [
                  {
                    name: "skeletor",
                    rawName: "v-skeletor:onChange",
                    value: _vm.setValue,
                    expression: "setValue",
                    arg: "onChange"
                  },
                  {
                    name: "permission-guard",
                    rawName: "v-permission-guard",
                    value: "views.admins.edit",
                    expression: "'views.admins.edit'"
                  }
                ],
                attrs: {
                  id: "admin.email",
                  type: "email",
                  label: _vm.$t("account.forms.email"),
                  placeholder: _vm.$t("account.forms.email"),
                  mandatory: true,
                  value: _vm.$v.updatedAdmin.email.$model,
                  readonly: _vm.action === "edit",
                  errormessage:
                    !_vm.$v.updatedAdmin.email.required &&
                    _vm.$v.updatedAdmin.email.$model !== null
                      ? _vm.$t("account.errors.fieldRequired")
                      : _vm.$v.updatedAdmin.email.$error ||
                        _vm.$v.updatedAdmin.email.$invalid
                      ? _vm.errorMessages.email
                      : null
                },
                model: {
                  value: _vm.$v.updatedAdmin.email.$model,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.$v.updatedAdmin.email,
                      "$model",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "$v.updatedAdmin.email.$model"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form__group col-2" },
            [
              _c("gl-input", {
                directives: [
                  {
                    name: "skeletor",
                    rawName: "v-skeletor:onChange",
                    value: _vm.setValue,
                    expression: "setValue",
                    arg: "onChange"
                  },
                  {
                    name: "permission-guard",
                    rawName: "v-permission-guard",
                    value: "views.admins.edit",
                    expression: "'views.admins.edit'"
                  }
                ],
                attrs: {
                  id: "admin.name",
                  type: "text",
                  label: _vm.$t("account.forms.name"),
                  placeholder: _vm.$t("account.forms.name"),
                  mandatory: true,
                  value: _vm.$v.updatedAdmin.name.$model,
                  errormessage:
                    !_vm.$v.updatedAdmin.name.required &&
                    _vm.$v.updatedAdmin.name.$model !== null
                      ? _vm.$t("account.errors.fieldRequired")
                      : _vm.$v.updatedAdmin.name.$error ||
                        !_vm.$v.updatedAdmin.name.isMaxLength
                      ? _vm.errorMessages.name
                      : null
                },
                model: {
                  value: _vm.$v.updatedAdmin.name.$model,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.$v.updatedAdmin.name,
                      "$model",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "$v.updatedAdmin.name.$model"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form__group col-2" },
            [
              _c("gl-input", {
                directives: [
                  {
                    name: "skeletor",
                    rawName: "v-skeletor:onChange",
                    value: _vm.setValue,
                    expression: "setValue",
                    arg: "onChange"
                  },
                  {
                    name: "permission-guard",
                    rawName: "v-permission-guard",
                    value: "views.admins.edit",
                    expression: "'views.admins.edit'"
                  }
                ],
                attrs: {
                  id: "admin.surname",
                  type: "text",
                  label: _vm.$t("account.forms.surname"),
                  placeholder: _vm.$t("account.forms.surname"),
                  value: _vm.$v.updatedAdmin.surname.$model
                },
                model: {
                  value: _vm.$v.updatedAdmin.surname.$model,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.$v.updatedAdmin.surname,
                      "$model",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "$v.updatedAdmin.surname.$model"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form__group col-2-fullrow" },
            [
              _c("gl-input", {
                directives: [
                  {
                    name: "skeletor",
                    rawName: "v-skeletor:onChange",
                    value: _vm.setValue,
                    expression: "setValue",
                    arg: "onChange"
                  },
                  {
                    name: "permission-guard",
                    rawName: "v-permission-guard",
                    value: "views.admins.edit",
                    expression: "'views.admins.edit'"
                  }
                ],
                attrs: {
                  id: "admin.pid",
                  type: "text",
                  label: _vm.$t("account.forms.dni"),
                  placeholder: _vm.$t("account.forms.dni"),
                  value: _vm.$v.updatedAdmin.pid.$model
                },
                model: {
                  value: _vm.$v.updatedAdmin.pid.$model,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.$v.updatedAdmin.pid,
                      "$model",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "$v.updatedAdmin.pid.$model"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form__group col-2-fullrow" },
            [
              _c("gl-input", {
                directives: [
                  {
                    name: "skeletor",
                    rawName: "v-skeletor:onChange",
                    value: _vm.setValue,
                    expression: "setValue",
                    arg: "onChange"
                  },
                  {
                    name: "permission-guard",
                    rawName: "v-permission-guard",
                    value: "views.admins.edit",
                    expression: "'views.admins.edit'"
                  }
                ],
                attrs: {
                  id: "admin.phone",
                  type: "text",
                  label: _vm.$t("account.forms.phone"),
                  placeholder: _vm.$t("account.forms.phone"),
                  value: _vm.$v.updatedAdmin.phone.$model
                },
                model: {
                  value: _vm.$v.updatedAdmin.phone.$model,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.$v.updatedAdmin.phone,
                      "$model",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "$v.updatedAdmin.phone.$model"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form__group col-2-fullrow" },
            [
              _c("gl-select", {
                directives: [
                  {
                    name: "permission-guard",
                    rawName: "v-permission-guard",
                    value: "views.admins.edit",
                    expression: "'views.admins.edit'"
                  },
                  {
                    name: "skeletor",
                    rawName: "v-skeletor:onChange",
                    value: _vm.setValue,
                    expression: "setValue",
                    arg: "onChange"
                  }
                ],
                attrs: {
                  id: "admin.lang",
                  label: _vm.$t("account.forms.lang"),
                  placeholder: _vm.$t("account.forms.lang"),
                  options: JSON.stringify(_vm.getLanguages),
                  mandatory: true,
                  value: JSON.stringify(_vm.$v.updatedAdmin.lang.$model),
                  separator: true,
                  errormessage: _vm.$v.updatedAdmin.lang.$error
                    ? _vm.$t("account.errors.fieldRequired")
                    : null
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form__group col-2-fullrow" },
            [
              _c("gl-select", {
                directives: [
                  {
                    name: "permission-guard",
                    rawName: "v-permission-guard",
                    value: "views.admins.edit",
                    expression: "'views.admins.edit'"
                  },
                  {
                    name: "skeletor",
                    rawName: "v-skeletor:onChange",
                    value: _vm.setValue,
                    expression: "setValue",
                    arg: "onChange"
                  }
                ],
                attrs: {
                  id: "admin.countryId",
                  label: _vm.$t("account.forms.country"),
                  placeholder: _vm.$t("account.forms.country"),
                  options: JSON.stringify(_vm.countries),
                  mandatory: true,
                  value: JSON.stringify(_vm.$v.updatedAdmin.countryId.$model),
                  separator: true,
                  errormessage: _vm.$v.updatedAdmin.countryId.$error
                    ? _vm.$t("account.errors.fieldRequired")
                    : null
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form__group col-2" },
            [
              _c("gl-select", {
                directives: [
                  {
                    name: "permission-guard",
                    rawName: "v-permission-guard",
                    value: "views.admins.edit",
                    expression: "'views.admins.edit'"
                  },
                  {
                    name: "skeletor",
                    rawName: "v-skeletor:onChange",
                    value: _vm.setValue,
                    expression: "setValue",
                    arg: "onChange"
                  }
                ],
                attrs: {
                  id: "admin.timezone",
                  label: _vm.$t("account.forms.timezone"),
                  placeholder: _vm.$t("account.forms.timezone"),
                  options: JSON.stringify(
                    _vm.getTimezones(_vm.updatedAdmin.countryId)
                  ),
                  mandatory: true,
                  disabled: !_vm.updatedAdmin.countryId,
                  value: JSON.stringify(_vm.$v.updatedAdmin.timezone.$model),
                  separator: true,
                  errormessage: _vm.$v.updatedAdmin.countryId.$error
                    ? _vm.$t("account.errors.fieldRequired")
                    : null
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form__group col-2-fullrow" },
            [
              _c("gl-select", {
                directives: [
                  {
                    name: "permission-guard",
                    rawName: "v-permission-guard",
                    value: "views.admins.edit",
                    expression: "'views.admins.edit'"
                  },
                  {
                    name: "skeletor",
                    rawName: "v-skeletor:onChange",
                    value: _vm.setValue,
                    expression: "setValue",
                    arg: "onChange"
                  }
                ],
                attrs: {
                  id: "admin.role",
                  label: _vm.$t("account.forms.rol"),
                  placeholder: _vm.$t("account.forms.rol"),
                  options: JSON.stringify(_vm.getRoles),
                  mandatory: true,
                  disabled: _vm.action === "edit",
                  value: JSON.stringify(_vm.$v.updatedAdmin.role.$model),
                  separator: true,
                  errormessage: _vm.$v.updatedAdmin.role.$error
                    ? _vm.$t("account.errors.fieldRequired")
                    : null
                }
              })
            ],
            1
          ),
          _c("div", { staticClass: "col-2-fullrow" }, [
            _c(
              "div",
              { staticClass: "account__block--checkbox" },
              [
                _c("gl-checkbox", {
                  directives: [
                    {
                      name: "permission-guard",
                      rawName: "v-permission-guard",
                      value: "views.admins.edit",
                      expression: "'views.admins.edit'"
                    },
                    {
                      name: "skeletor",
                      rawName: "v-skeletor:onChange",
                      value: _vm.setValue,
                      expression: "setValue",
                      arg: "onChange"
                    }
                  ],
                  attrs: {
                    id: "admin.blocked",
                    label: _vm.$t("admins.blockAdmin"),
                    placeholder: _vm.$t("admins.blockAdmin"),
                    checked: _vm.updatedAdmin.blocked,
                    small: true
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "account__block--checkbox" },
              [
                _c("gl-checkbox", {
                  directives: [
                    {
                      name: "permission-guard",
                      rawName: "v-permission-guard",
                      value: "views.admins.edit",
                      expression: "'views.admins.edit'"
                    },
                    {
                      name: "skeletor",
                      rawName: "v-skeletor:onChange",
                      value: _vm.setValue,
                      expression: "setValue",
                      arg: "onChange"
                    }
                  ],
                  attrs: {
                    id: "admin.isCreator",
                    label: _vm.$t("admins.accessEditor"),
                    checked: _vm.updatedAdmin.isCreator,
                    readonly: _vm.updatedAdmin.role === "creator",
                    small: true
                  }
                })
              ],
              1
            )
          ])
        ])
      ]),
      _vm.shouldShowNotificationsCfg
        ? [
            _c(
              "div",
              { staticClass: "gl-forms__container" },
              [
                _c("div", { staticClass: "gl-forms__title" }, [
                  _vm._v(" " + _vm._s(_vm.$t("admins.notifications")) + " ")
                ]),
                _vm.shouldShowNa2Cfg
                  ? [
                      _c("div", { staticClass: "form__row" }, [
                        _c(
                          "div",
                          { staticClass: "account__block--checkbox" },
                          [
                            _c("gl-checkbox", {
                              directives: [
                                {
                                  name: "permission-guard",
                                  rawName: "v-permission-guard",
                                  value: "views.admins.edit",
                                  expression: "'views.admins.edit'"
                                },
                                {
                                  name: "skeletor",
                                  rawName: "v-skeletor:onChange",
                                  value: _vm.setNotifications,
                                  expression: "setNotifications",
                                  arg: "onChange"
                                }
                              ],
                              attrs: {
                                id: "admin.notifications.na2.enabled",
                                label: _vm.$t("admins.mailResumeActivity"),
                                placeholder: _vm.$t(
                                  "admins.mailResumeActivity"
                                ),
                                tooltip: _vm.$t(
                                  "admins.mailResumeActivityTooltip"
                                ),
                                checked:
                                  _vm.updatedAdmin.notificationsCfg.na2.enabled,
                                small: true
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "form__group" },
                          [
                            _c("gl-select", {
                              directives: [
                                {
                                  name: "permission-guard",
                                  rawName: "v-permission-guard",
                                  value: "views.admins.edit",
                                  expression: "'views.admins.edit'"
                                },
                                {
                                  name: "skeletor",
                                  rawName: "v-skeletor:onChange",
                                  value: _vm.setNotifications,
                                  expression: "setNotifications",
                                  arg: "onChange"
                                }
                              ],
                              attrs: {
                                id: "admin.notifications.na2.weekPeriodicity",
                                label: _vm.$t(
                                  "admins.mailFrequencyResumeActivity"
                                ),
                                placeholder: _vm.$t(
                                  "admins.mailFrequencyResumeActivity"
                                ),
                                options: JSON.stringify(_vm.weeks),
                                mandatory: true,
                                value: JSON.stringify(
                                  _vm.updatedAdmin.notificationsCfg.na2
                                    .weekPeriodicity
                                ),
                                separator: true,
                                disabled:
                                  _vm.updatedAdmin.notificationsCfg.na2
                                    .enabled !== true,
                                errormessage: !_vm.updatedAdmin.notificationsCfg
                                  ? _vm.$t("account.errors.fieldRequired")
                                  : null
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  : _vm._e()
              ],
              2
            )
          ]
        : _vm._e(),
      _c(
        "div",
        { staticClass: "gl-grid-form__buttons margin-auto" },
        [
          _vm.action === "create"
            ? _c("gl-button", {
                directives: [
                  {
                    name: "permission-guard",
                    rawName: "v-permission-guard",
                    value: "views.admins.add",
                    expression: "'views.admins.add'"
                  }
                ],
                staticClass: "btn",
                attrs: {
                  id: "admin.btn-cancel",
                  "color-secondary": "",
                  type: "button",
                  text: _vm.$t("account.forms.cancel")
                },
                on: {
                  onClick: function($event) {
                    return _vm.$router.push({ name: "admins" })
                  }
                }
              })
            : _vm._e(),
          _vm.action === "create"
            ? _c("gl-button", {
                directives: [
                  {
                    name: "permission-guard",
                    rawName: "v-permission-guard",
                    value: "views.admins.add",
                    expression: "'views.admins.add'"
                  }
                ],
                attrs: {
                  id: "admin.btn-add",
                  "color-primary": "",
                  type: "submit",
                  text: _vm.$t("admins.addAdmin"),
                  disabled: _vm.$v.$invalid || !_vm.dirtyFields
                },
                on: {
                  onClick: function($event) {
                    return _vm.saveAdmin(_vm.updatedAdmin)
                  }
                }
              })
            : _vm._e(),
          _vm.action === "edit"
            ? _c("gl-button", {
                directives: [
                  {
                    name: "permission-guard",
                    rawName: "v-permission-guard",
                    value: "views.admins.edit",
                    expression: "'views.admins.edit'"
                  }
                ],
                attrs: {
                  id: "admin.btn-save",
                  "color-primary": "",
                  type: "submit",
                  text: _vm.$t("account.forms.saveChanges"),
                  disabled: _vm.$v.$invalid || !_vm.dirtyFields
                },
                on: {
                  onClick: function($event) {
                    $event.preventDefault()
                    return _vm.saveAdmin(_vm.updatedAdmin)
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm.showLimitError ? _c("AdminLimitModal") : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }